import { defineStore } from 'pinia';
import { type UserState } from './types';
import { ref } from 'vue';
import { getToken } from '@/utils/auth';
import { $fetch } from '@/utils/base-fetch';
import { $fetch as $fetchWithAuth } from '@/utils/fetch';
import {
  HEADER_KEY_TOKEN,
  HEADER_KEY_SITE,
  HEADER_KEY_LANGUAGE,
  DEFAULT_LANGUAGE,
  SITE_CODE,
} from '@/utils/constants';

const useUserStore = defineStore('user', () => {
  const getInitUser = (): UserState => ({
    id: undefined,
    photo: undefined,
    username: undefined,
    nickname: undefined,
    email: undefined,
    phone: undefined,
    isJoined: undefined,
  });

  const user = ref<UserState>(getInitUser());

  const setInfo = (partial: Partial<UserState>) => {
    user.value = { ...user.value, ...partial };
  }

  const resetInfo = () => {
    user.value = getInitUser();
  }

  // Get user's information
  const fetchInfo = async (cookie?: string) => {
    if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
      setInfo({
        id: '1',
        photo: 'https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png',
        email: 'wangliqun@email.com',
        username: 'wangliqun',
        nickname: 'wlq',
      });

      return {
        isSuccess: true,
        code: 200,
      };
    }
    else {
      const { isSuccess, data, msg, code } = await $fetch('/api/auth/v1/users/me', {
        headers: {
          [HEADER_KEY_SITE]: SITE_CODE,
          [HEADER_KEY_LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER_KEY_TOKEN]: getToken(cookie),
        },
      });

      if (isSuccess) {
        setInfo({
          id: data.id,
          photo: data.avatarUrl,
          email: data.email,
          username: data.username,
          nickname: data.nickname,
          isJoined: Boolean(data.isJoined),
        });
      }

      return {
        isSuccess, msg,
        code: Number(code),
      };
    }
  }

  const joinCommunity = async () => {
    const { isSuccess, data } = await $fetchWithAuth('/api/member/v1/community/join', {
      data: {
        action: 'join',
      },
    });

    if (isSuccess) {
      setInfo({ isJoined: true });
    }

    return {
      isSuccess,
      communityMemberCount: data?.communityMemberCount,
    };
  }

  return {
    user,
    setInfo,
    resetInfo,
    fetchInfo,
    joinCommunity,
  };
});

export default useUserStore;
